import { useTLang } from 'intl/intl';

export function useShutdownTimeLang() {
  return {
    title: useTLang({ id: 'menuPage.shutdownTime.title' }),
    option: {
      daily: {
        title: useTLang({ id: 'menuPage.shutdownTime.option.daily.title' }),
        description: useTLang({
          id: 'menuPage.shutdownTime.option.daily.description',
        }),
      },
      custom: {
        title: useTLang({ id: 'menuPage.shutdownTime.option.custom.title' }),
        description: useTLang({
          id: 'menuPage.shutdownTime.option.custom.description',
        }),
        hasDate: {
          false: useTLang({
            id: 'menuPage.shutdownTime.option.custom.hasDate.false',
          }),
          true: useTLang({
            id: 'menuPage.shutdownTime.option.custom.hasDate.true',
          }),
        },
      },
      permanent: {
        title: useTLang({ id: 'menuPage.shutdownTime.option.permanent.title' }),
        description: useTLang({
          id: 'menuPage.shutdownTime.option.permanent.description',
        }),
      },
    },
  };
}
